const insuranceTabData = [
  {
    page: "car",
    tabs: [
      {
        id: "1",
        tabButton: "ACKO Car Insurance",
        header: "Car insurance on ACKO",
        content:
          "Save costs, comply with law, and stay hassle-free with ACKO’s online car insurance policy.",
      },
      {
        id: "2",
        tabButton: "Buying Guide",
        header: "How to buy car insurance online from ACKO?",
        content:
          "Share details, customise plans, and make the payment - that effortless it is to buy a car insurance policy. Here are 3 simple steps to buy/renew a car insurance policy from ACKO.",
      },
      {
        id: "3",
        tabButton: "Car Insurance in India",
        header: "The need for car insurance in India",
        content:
          "As per the report by Insurance Information Bureau (IIB), approximately 23 crore vehicles were running on the Indian roads as of 31st March 2019. While India ranked fourth across the globe with respect to the vehicles manufactured in 2019, the bike and car insurance penetration showed signs of worry. Out of 23 crore vehicles in the country, 57% were uninsured. If we do a quick calculation, approx. 13 crore Indian vehicles did not even have a mandatory Third-party insurance policy. Here are a few more reasons why insurance for cars/bikes is necessary in our country.",
      },
    ],
  },
  {
    page: "bike",
    tabs: [
      {
        id: "1",
        tabButton: "ACKO Two-wheeler Insurance",
        header: "Bike insurance on ACKO",
        content:
          "Low-cost bike insurance plans with exciting discounts - Buy online on ACKO.",
        
      },
      {
        id: "2",
        tabButton: "Buying Guide",
        header: "What is bike insurance/two-wheeler insurance policy?",
        content: "",
      },
      {
        id: "3",
        tabButton: "Bike Insurance in India",
        header: "Growth of the two-wheeler industry in India",
        content:
          "The growth of the domestic two-wheeler sales was at a compounded annual growth rate (CAGR) of 5.8% between FY14-15 and FY18-19. With this, the domestic total sales trend has also shown a CAGR growth of 5.8% over the same period. Let’s look into the contribution of this vehicle segment to the Indian automobile industry.",
      },
    ],
  },
  //   {
  //     page: "health",
  //     tabs: [
  //       {
  //         title: "ACKO Health Insurance",
  //         header: "Bike insurance on ACKO",
  //         content:
  //           "Low-cost bike insurance plans with exciting discounts - Buy online on ACKO.",
  //       },
  //       {
  //         title: "Buying Guide",
  //         header: "What is bike insurance/two-wheeler insurance policy?",
  //         content: "",
  //       },
  //       {
  //         title: "Bike Insurance in India",
  //         header: "Growth of the two-wheeler industry in India",
  //         content:
  //           "The growth of the domestic two-wheeler sales was at a compounded annual growth rate (CAGR) of 5.8% between FY14-15 and FY18-19. With this, the domestic total sales trend has also shown a CAGR growth of 5.8% over the same period. Let’s look into the contribution of this vehicle segment to the Indian automobile industry.",
  //       },
  //     ],
  //   },
];
export default insuranceTabData;
